export const WEEKS_IN_YEAR = 52;
export const WEEKS_IN_MONTH_FROM = 4;
export const WEEKS_IN_MONTH_TO = 4.4;
export const MONTHS_IN_YEAR = 12;

export const weeklyFromMonthly = (monthly) => (monthly != null ? Math.ceil(monthly / WEEKS_IN_MONTH_TO) : null);

export const weeklyFromYearly = (annual) => (annual != null ? Math.ceil(annual / WEEKS_IN_YEAR) : null);

export const getWeeklyProductUsage = (limits, isDigital) => {
    const specific = isDigital
        ? limits.digitalWeeklyLimit ?? weeklyFromMonthly(limits.digitalMonthlyLimit) ?? weeklyFromYearly(limits.digitalAnnualLimit)
        : limits.physicalWeeklyLimit ?? weeklyFromMonthly(limits.physicalMonthlyLimit) ?? weeklyFromYearly(limits.physicalAnnualLimit);

    if (specific != null) {
        return { limit: specific, count: isDigital ? limits.digitalWeeklyProductsCount : limits.physicalWeeklyProductsCount };
    }

    const general = limits.weeklyLimit ?? weeklyFromMonthly(limits.monthlyLimit) ?? weeklyFromYearly(limits.annualLimit);

    return { limit: general, count: limits.weeklyProductsCount };
};
